<template>
    <div class="original-edit">
        <!-- 返回上一页 -->
        <div class="original-edit-nav">
            <a href="javascript:;"
                class="original-edit-nav-back"
                @click="$router.go(-1)">
                返回上一步
            </a>
            <span>/</span>
            <span>上传</span>
        </div>
        <!-- 表单 -->
        <div class="original-edit-form">
            <el-form
                :model="form"
                :rules="rules"
                ref="submitForm"
                label-width="100px">
                <!-- 名称 -->
                <el-form-item
                    label="模板名称">
                    <el-input
                        v-model="form.goods_name"
                        class="original-edit-form-input"
                        placeholder="请输入模板名称">
                    </el-input>
                </el-form-item>
                <!-- 封面图片 -->
                <el-form-item
                    label="封面图片">
                    <div class="original-edit-form-remarks">
                        建议图片大小2M以内
                    </div>
                    <el-upload
                        action="#"
                        list-type="picture-card"
                        :auto-upload="false"
                        :file-list="form.goods_cover"
                        :limit="1"
                        :on-change="handleCover"
                        :on-remove="removeCover"
                        class="original-edit-form-pic">
                        <template #trigger>
                            <i class="el-icon-plus"></i>
                        </template>
                    </el-upload>
                </el-form-item>
                <!-- 预览图
                <el-form-item
                    label="预览图">
                    <div class="original-edit-form-remarks">
                        建议图片大小2M以内
                    </div>
                    <el-upload
                        action="#"
                        list-type="picture-card"
                        :auto-upload="false"
                        :file-list="form.goods_pic"
                        :on-change="handlePreview"
                        :on-remove="removePreview"
                        class="original-edit-form-pic">
                        <template #trigger>
                            <i class="el-icon-plus"></i>
                        </template>
                    </el-upload>
                </el-form-item>
                -->
              <!-- 备注 -->
              <el-form-item label="备注">
                <el-input
                    v-model="form.synopsis"
                    type="textarea"
                    :rows="2"
                    placeholder="您可以在这里说明希望将素材应用到什么场景和提出您的要求"
                >
                </el-input>
              </el-form-item>
                <el-form-item
                    label="源文件上传">
                    <el-upload
                        action="#"
                        :auto-upload="false"
                        :on-change="handleSource"
                        :limit="1">
                        <el-button size="small" type="primary">
                            点击上传
                        </el-button>
                    </el-upload>
                </el-form-item>
                <div v-if="false">
                    <!-- 模板类型 -->
                    <el-form-item
                        label="类型">
                        <el-cascader
                            v-model="form.goods_type"
                            :options="filterType"
                            separator=">"
                            @change="getMetopeFilters">
                        </el-cascader>
                    </el-form-item>
                    <!-- 风格 -->
                    <el-form-item
                        label="风格">
                        <el-checkbox-group
                            v-model="form.goods_style">
                            <el-checkbox
                                v-for="(item, index) in filterStyle"
                                :key="index"
                                :label="item.value">
                                {{item.label}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <!-- 模板价格 -->
                    <el-form-item
                        label="价格">
                        <el-input
                            v-model="form.goods_price"
                            class="original-edit-form-input"
                            placeholder="请输入价格">
                        </el-input>
                    </el-form-item>
                    <!-- 模板单位 -->
                    <el-form-item
                        label="单位">
                        <el-input
                            v-model="form.goods_unit"
                            class="original-edit-form-input"
                            placeholder="请输入单位">
                        </el-input>
                    </el-form-item>
                    <!-- 规格 -->
                    <template v-for="(item, index) in specList">
                        <el-form-item :key="index+'名称'"
                            :label="'规格'+(index+1)+'名称'">
                            <el-input
                                v-model="item.label"
                                class="original-edit-form-input">
                            </el-input>
                            <!-- 添加 -->
                            <el-button
                                type="primary"
                                @click="handleSpec('add')"
                                class="edit-btn"
                                circle>
                                <i class="el-icon-plus"></i>
                            </el-button>
                            <!-- 删除 -->
                            <el-button
                                type="danger"
                                @click="handleSpec('del', index)"
                                circle>
                                <i class="el-icon-delete"></i>
                            </el-button>
                        </el-form-item>
                        <el-form-item :key="index+'值'"
                            :label="'规格'+(index+1)+'值'">
                            <div class="form-tag">
                                <!-- 标签 -->
                                <template v-if="item.tags.length > 0">
                                    <el-tag
                                        v-for="tag in item.tags"
                                        :key="tag.id"
                                        @close="handleCloseTag(tag, index)"
                                        closable>
                                        {{tag}}
                                    </el-tag>
                                </template>
                                <!-- 输入 -->
                                <el-input
                                    v-model="item.tagInput"
                                    size="mini"
                                    placeholder="请输入值"
                                    @keyup.enter.native="handleAddTag(index)"
                                    @blur="handleAddTag(index)"
                                    class="form-tag-input">
                                </el-input>
                            </div>
                        </el-form-item>
                    </template>
                    <el-form-item
                        label="">
                        <el-button
                            type="primary"
                            size="mini"
                            @click="createTbale(specList)">
                            生成表格
                        </el-button>
                    </el-form-item>
                    <el-form-item
                        v-if="tableData.length > 0">
                        <original-edit-table
                            :table-column="specList"
                            :table-data="tableData">
                        </original-edit-table>
                    </el-form-item>
                </div>
              <!-- 协议 -->
              <el-form-item
                  label=""
                  prop="checked">
                <el-checkbox v-model="form.checked">
                  我已阅读并同意
                  <a href="http://www.ijustsharing.com/public/business_agreement.html"
                     target="view_frame">
                    《吉享空间原创作品使用协议》
                  </a>
                </el-checkbox>
              </el-form-item>
            </el-form>
            <!-- 上传按钮 -->
            <div class="original-edit-submit">
                <el-button
                    type="primary"
                    class="original-edit-upload-file"
                    @click="handleSubmit(form, $route.query.id)"
                    round>
                    确认上传
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from "vuex";
    import { picUtils } from "@/tool/picUtils.js";
    export default {
        mixins: [ picUtils ],
        data() {
            let validataChecked = (rule, value, callback) => {
              if(!value){
                callback(new Error('您未同意协议'));
              }else{
                callback();
              }
            };
            return {
                form: {
                    goods_id: '',
                    goods_name: "",
                    goods_cover: [],
                    goods_pic: [],
                    goods_price: "",
                    goods_unit: "",
                    goods_type: '',
                    goods_style: [],
                    checked: false,  // 协议
                },
                rules: {
                  checked: [
                    { required: true, validator: validataChecked, trigger: 'blur' },
                  ],
                },
                specList: [ // 初始化必须携带一组空参数
                    {
                        label: '',
                        tags: [],
                        tagInput: ''
                    }
                ],
                tableData: []
            }
        },
        computed: mapState({
            user_id: state => state.user.user_id,
            templateDetail: state => state.original.templateDetail,
            filterStyle: state => state.metope.filterStyle,
            filterType: state => state.metope.filterType
        }),
        components: {
            originalEditTable: () => import('@/components/original/original-edit-table')
        },
        watch: {
            templateDetail: {
                handler: function(value){
                    let {
                            id = '',
                            name = '',
                            images = [],
                            preview = [],
                            type = '',
                            style = [],
                            price = '',
                            unit = '',
                            specList = [],
                            priceList = []
                        } = value,
                        goods_cover = [],
                        goods_pic = [];

                    if(images.length > 0){
                        images.map((item) => {
                            goods_cover.push({
                                status: 'success',
                                url: item
                            })
                        })
                    }
                    if(preview.length > 0){
                        preview.map((item) => {
                            goods_pic.push({
                                status: 'success',
                                url: item
                            })
                        })
                    }
                    if(JSON.stringify(specList) == '[]'){
                        specList = [
                            {
                                label: '',
                                tags: [],
                                tagInput: ''
                            }
                        ]
                    }

                    this.form = {
                        goods_id: id,
                        goods_name: name,
                        goods_cover,
                        goods_pic,
                        goods_price: price,
                        goods_unit: unit,
                        goods_type: type,
                        goods_style: style,
                    }
                    this.specList = specList;
                    this.tableData = priceList;
                    this.getMetopeFilters(type)
                },
                immediate: true
            }
        },
        methods: {
            ...mapMutations([
                'setTemplateDetail',
                'setMetopeFilters'
            ]),
            ...mapActions([
                'handleTemplateDetail',
                'handleUploadImage',
                'getTemplateDetail',
                'getMetopeFilters'
            ]),
            handleCover(file, fileList) {
                this.handleBASE64(file.raw)
                    .then(res => {
                        return this.handleUploadImage(res)
                    }).then(res => {
                        this.form.goods_cover.push({
                            url: res.result
                        })
                    })
            },
            removeCover(file, fileList) {
                this.form.goods_cover.map((item, index) => {
                    if(item.url == file.url){
                        this.form.goods_cover.splice(index, 1);
                    }
                })
            },
            handlePreview(file, fileList) {
                this.handleBASE64(file.raw)
                    .then(res => {
                        return this.handleUploadImage(res)
                    }).then(res => {
                        this.form.goods_pic.push({
                            url: res.result
                        })
                    })
            },
            removePreview(file, fileList) {
                this.form.goods_pic.map((item, index) => {
                    if(item.url == file.url){
                        this.form.goods_pic.splice(index, 1);
                    }
                })
            },
            handleSource(file, fileList) {
                console.log({file, fileList})
            },
            handleImageList(list) {
                let newList = [];
                list.map(item => {
                    newList.push(item.url);
                })
                return newList.join('|')
            },
            handleCartesian(arr, skuarr=[], i, list) { // 计算笛卡尔乘积
                for (let j=0; j<list[i].length; j++) {
                    if (i<list.length-1) {
                        skuarr[i] = list[i][j];
                        this.handleCartesian(arr, skuarr, i+1, list);
                    } else {
                        arr.push([...skuarr,list[i][j]]);
                    }
                }
                return arr
            },
            createTbale(data) { // 生成表格
                let tags = [], arr = [], res = [], table = [];
                data.map(item => {
                    tags.push(item.tags);
                })
                res = this.handleCartesian(arr, [], 0, tags);
                res.map((tag, index) =>{
                    table[index] = {};
                    table[index].price = '';
                    table[index].spec = tag;
                })
                this.tableData = table;
            },
            handleSpec(type, index) { // 添加或删除规格
                if(type === 'del' && this.specList.length > 1){
                    this.specList.splice(index, 1);
                }else if (type === 'add' && this.specList.length < 2){
                    this.specList.push({
                        name: '',
                        id: '',
                        tags: [],
                        tagInput: ''
                    })
                }
            },
            handleCloseTag(tag, index) { // 删除规格值
                this.specList[index].tags.splice(this.specList[index].tags.indexOf(tag), 1);
            },
            handleAddTag(index) { // 添加规格值
                // 需要添加数组重复值剔除
                let value = this.specList[index].tagInput;
                if(value){
                    this.specList[index].tags.push(value);
                }
                this.specList[index].tagInput = '';
            },
            //oss上传
            handleChoicer(arg){
                 // 上传图片到OSS 同时派发一个事件给父组件监听
                  getAliOSSCreds().then(res => { // 向后台发请求 拉取OSS相关配置
                   let creds = res.body.data
                   let client = new OSS.Wrapper({
                    region: 'oss-cn-beijing', // 服务器集群地区
                    accessKeyId: creds.accessKeyId, // OSS帐号
                    accessKeySecret: creds.accessKeySecret, // OSS 密码
                    stsToken: creds.securityToken, // 签名token
                    bucket: 'imgXXXX' // 阿里云上存储的 Bucket
                   })
                   let key = 'resource/' + localStorage.userId + '/images/' + createId() + '.jpg' // 存储路径，并且给图片改成唯一名字
                   return client.put(key, item.file) // OSS上传
                  }).then(res => {
                   console.log(res.url)
                   this.$emit('on-success', res.url) // 返回图片的存储路径
                  }).catch(err => {
                   console.log(err)
                  })
            },
            handleSubmit(form, id = ''){
                this.$refs.submitForm.validate((valid) => {
                  if(!valid){
                    return;
                  } else {
                    let params = {
                      userID: this.user_id,
                      name: form.goods_name,
                      images: this.handleImageList(form.goods_cover),
                      preview: this.handleImageList(form.goods_pic),
                      type: form.goods_type,
                      style: form.goods_style,
                      price: form.goods_price,
                      unit: form.goods_unit,
                      specList: this.specList,
                      priceList: this.tableData
                    }
                    id == '' || (params.worksID = form.goods_id);
                    if(id == ''){
                      console.log('add is click');
                    }else{
                      console.log('edit is click');
                    }
                    this.handleTemplateDetail(params)
                        .then( res => {
                          this.$message({
                            showClose: true,
                            message: res.msg,
                            type: res.type
                          })
                          res.type == 'success' && this.$router.go(-1);
                        }).catch(err => {
                      this.$message({
                        showClose: true,
                        message: err,
                        type: 'error'
                      })
                    })
                  } //End else
                })//End validate
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                const worksID = to.query.id;
                if(worksID){
                    vm.getTemplateDetail({
                        userID: vm.user_id,
                        worksID
                    });
                }
                vm.getMetopeFilters();
            })
        },
        beforeRouteLeave (to, from, next) {
            this.setTemplateDetail({});
            this.setMetopeFilters({})
            next();
        }
    }
</script>

<style scoped>
/* 导航 */
.original-edit-nav-back{
    color: #8d9afc;
}
.original-edit-nav > span{
    margin-left: 10px;
    color: #909399;
}
/* 表单 */
.original-edit-form{
    margin-top: 30px;
}
/* 备注 */
.original-edit-form-remarks{
    color: #e6a23c;
}
/* 输入框 */
.original-edit-form-input{
    width: 200px;
}
.edit-btn{
    margin-left: 10px;
}
.form-tag {
    display: flex;
    align-items: center;
}
.el-tag {
    margin-right: 10px;
}
.form-tag-input {
    width: 80px;
}
</style>
